import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import CreateEditViewStockAudit from "../../../components/inventory/stock-audit/create-edit-view-stock-audit";
import { stockAuditViewAction } from "../../../redux/actions/stock-details-audit-action";
import InnerLayout from "../../../components/layouts/inner-layout";

const EditStockAudit = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [audit, setAudit] = useState({});
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    dispatch(stockAuditViewAction({ sat_id: id }, onSuccess, onError));
  }, []);
  const onSuccess = (data) => {
    setLoading(false);
    setAudit(data?.data);
  };
  const onError = (data) => {
    setLoading(false);
  };
  return (
    <InnerLayout backBtn={true} title="Edit Stock Audit">
      <CreateEditViewStockAudit
        loading={loading}
        setLoading={setLoading}
        page="edit"
        audit={audit}
        disabled={false}
      />
    </InnerLayout>
  );
};

export default EditStockAudit;
